import React from 'react';
import { Target, Calculator, Activity } from 'lucide-react';

/**
 * Секция выбора цели, уровня активности и формулы расчета TDEE
 */
const GoalAndFormulaSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  goals,
  formulas,
  activityLevels
}) => {
  return (
    <div className="mb-6 bg-emerald-50 dark:bg-emerald-900/20 p-4 rounded-lg border border-emerald-200 dark:border-emerald-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Target className="w-5 h-5 mr-2 text-emerald-500" />
        Цель и уровень активности
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Уровень активности */}
        <div>
          <label htmlFor="activityLevel" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Activity className="w-4 h-4 mr-2 text-emerald-500" />
            Уровень активности
          </label>
          <select
            id="activityLevel"
            name="activityLevel"
            value={formData.activityLevel}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.activityLevel ? 'input-error' : ''}`}
          >
            {activityLevels.map((level) => (
              <option key={level.id} value={level.id}>
                {level.name}
              </option>
            ))}
          </select>
          {errors.activityLevel && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.activityLevel}
            </p>
          )}
          {/* Описание выбранного уровня активности */}
          <p className="mt-2 text-xs text-emerald-700 dark:text-emerald-400">
            {activityLevels.find(level => level.id === formData.activityLevel)?.description}
          </p>
        </div>

        {/* Цель */}
        <div>
          <label htmlFor="goal" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Target className="w-4 h-4 mr-2 text-emerald-500" />
            Ваша цель
          </label>
          <select
            id="goal"
            name="goal"
            value={formData.goal}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.goal ? 'input-error' : ''}`}
          >
            {goals.map((goal) => (
              <option key={goal.id} value={goal.id}>
                {goal.name}
              </option>
            ))}
          </select>
          {errors.goal && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.goal}
            </p>
          )}
          {/* Описание выбранной цели */}
          <p className="mt-2 text-xs text-emerald-700 dark:text-emerald-400">
            {goals.find(g => g.id === formData.goal)?.description}
          </p>
        </div>

        {/* Формула расчета */}
        <div className="col-span-full">
          <label htmlFor="formula" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Calculator className="w-4 h-4 mr-2 text-emerald-500" />
            Формула расчета
          </label>
          <select
            id="formula"
            name="formula"
            value={formData.formula}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.formula ? 'input-error' : ''}`}
          >
            {formulas.map((formula) => (
              <option key={formula.id} value={formula.id}>
                {formula.name}
              </option>
            ))}
          </select>
          {errors.formula && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.formula}
            </p>
          )}
          {/* Описание выбранной формулы */}
          <p className="mt-2 text-xs text-emerald-700 dark:text-emerald-400">
            {formulas.find(f => f.id === formData.formula)?.description}
          </p>
        </div>

        {/* Учитывать возрастные особенности */}
        <div className="col-span-full mt-2">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="adjustForAge"
              checked={formData.adjustForAge}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать возрастные особенности метаболизма
            </span>
          </label>
          <p className="mt-1 text-xs text-emerald-700 dark:text-emerald-400 pl-6">
            Корректирует расчеты для детей, подростков и пожилых людей
          </p>
        </div>
      </div>
    </div>
  );
};

export default GoalAndFormulaSection;